export const translations = {
  en: {
    // Navbar
    'nav.shopNow': 'Shop Now',
    'nav.myOrders': 'My Orders',
    'nav.allVarieties': 'All Varieties',
    'nav.recipes': 'Recipes',
    'nav.podcasts': 'Podcasts',
    'nav.about': 'About',
    'nav.shopByVariety': 'Shop by Variety',
    'nav.viewAll': 'View All →',
    'nav.menu': 'Menu',

    // Hero
    'hero.badge': '100% Certified Organic',
    'hero.title': 'PIIKK Agro Farm Fresh Mushrooms',
    'hero.subtitle': "Nature's finest mushrooms — grown fresh, delivered to your door.",
    'hero.shopNow': 'Shop Now',
    'hero.explore': 'Explore Varieties',

    // Trust badges
    'trust.organic': '100% Certified Organic',
    'trust.organicSub': 'No pesticides, ever',
    'trust.delivery': 'Farm-Fresh Delivery',
    'trust.deliverySub': 'Delivered within 24h',
    'trust.quality': 'Quality Guaranteed',
    'trust.qualitySub': 'Hand-picked at peak freshness',

    // Featured section
    'featured.label': 'Our Selection',
    'featured.title': 'Featured Varieties',
    'featured.seeAll': 'See all',
    'featured.addToCart': 'Add to Cart',
    'featured.preOrder': 'Pre-Order',
    'featured.outOfStock': 'Out of Stock',
    'featured.upcoming': 'Coming Soon',

    // Story section
    'story.label': 'Our Story',
    'story.title': 'Rooted in Varanasi\'s Soil',

    // Stats
    'stats.varieties': 'Varieties',
    'stats.pesticides': 'Pesticides on crop',
    'stats.graded': 'Grade-checked',
    'stats.delivery': 'Farm-to-door',

    // About
    'about.productionUnit': 'Production Unit',

    // Shop page
    'shop.label': 'PIIKK Agro Farm Fresh Mushrooms',
    'shop.title': 'All Varieties',
    'shop.subtitle': '{n} varieties of certified organic mushrooms, priced per pack.',
    'shop.searchPlaceholder': 'Search mushrooms...',
    'shop.all': 'All',
    'shop.addToCart': 'Add to Cart',
    'shop.preOrder': 'Pre-Order',
    'shop.inCart': 'In Cart',
    'shop.upcoming': 'Coming Soon',
    'shop.noResults': 'No mushrooms found.',
    'shop.perPack': 'per pack',

    // Mushroom Detail
    'detail.backToShop': 'Back to Shop',
    'detail.addToCart': 'Add to Cart',
    'detail.preOrder': 'Pre-Order Now',
    'detail.benefits': 'Benefits',
    'detail.uses': 'Uses & Applications',
    'detail.recipes': 'Recipes',
    'detail.cookingTip': 'Cooking Tip',
    'detail.relatedTitle': 'You May Also Like',
    'detail.inStock': 'In Stock',
    'detail.upcoming': 'Pre-Order Only',
    'detail.uom': 'per pack',

    // Cart
    'cart.title': 'Your Cart',
    'cart.empty': 'Your cart is empty',
    'cart.emptySubtext': 'Add some fresh mushrooms to get started',
    'cart.shopNow': 'Shop Now',
    'cart.checkout': 'Order via WhatsApp',
    'cart.total': 'Total',
    'cart.items': 'items',
    'cart.remove': 'Remove',
    'cart.inStock': 'In stock',

    // Pre-Order Modal
    'preorder.title': 'Pre-Order',
    'preorder.enquiryTitle': 'Availability Enquiry',
    'preorder.name': 'Your Name',
    'preorder.namePlaceholder': 'Full name',
    'preorder.phone': 'Phone Number',
    'preorder.phonePlaceholder': '10-digit mobile number',
    'preorder.address': 'Delivery Address',
    'preorder.addressPlaceholder': 'House no., Street, Area, City, Pincode',
    'preorder.qty': 'Quantity',
    'preorder.date': 'Preferred Delivery Date',
    'preorder.dateUnavailable': 'Preferred Date (unavailable)',
    'preorder.notes': 'Notes (optional)',
    'preorder.enquiryNotes': 'Message (optional)',
    'preorder.notesPh': 'Any special requirements?',
    'preorder.enquiryNotesPh': 'Any questions or requirements?',
    'preorder.submit': 'Confirm Pre-Order via WhatsApp',
    'preorder.enquirySubmit': 'Send Enquiry via WhatsApp',
    'preorder.loading': 'Saving...',
    'preorder.verifyNote': 'You\'ll be asked to verify your phone number.',
    'preorder.verifiedNote': 'Phone verified. Your order will be saved.',
    'preorder.successTitle': 'Pre-Order Placed!',
    'preorder.enquirySuccessTitle': 'Enquiry Submitted!',
    'preorder.successMsg': 'Your pre-order for {name} has been placed. Tap below to inform us on WhatsApp so we can confirm your delivery date.',
    'preorder.enquirySuccessMsg': 'Your enquiry for {name} has been recorded. Tap below to send it on WhatsApp so we can get back to you.',
    'preorder.whatsapp': 'Inform us on WhatsApp',
    'preorder.close': 'Close',
    'preorder.comingSoon': 'Coming soon · Enquire for availability',
    'preorder.chooseBetween': 'Choose between {from} and {until}',
    'preorder.noDatesSet': 'Dates not set yet — we\'ll confirm with you.',
    'preorder.enquiryInfo': 'No pre-order window is set yet. We\'ll contact you once this variety is available.',

    // Order Form Modal
    'order.title': 'Complete Your Order',
    'order.name': 'Your Name',
    'order.namePh': 'Full name',
    'order.phone': 'Phone Number',
    'order.phonePh': '10-digit mobile number',
    'order.address': 'Delivery Address',
    'order.addressPh': 'House no., Street, Area, City, Pincode',
    'order.confirm': 'Confirm Order via WhatsApp',
    'order.verifyNote': 'You\'ll verify your phone to confirm.',
    'order.verifiedNote': 'Phone verified. Your order will be saved.',
    'order.successTitle': 'Order Placed!',
    'order.successMsg': 'Your order has been placed. Tap below to inform us on WhatsApp so we can arrange delivery.',
    'order.orderId': 'Order ID',
    'order.whatsapp': 'Inform us on WhatsApp',
    'order.close': 'Close',

    // OTP Modal
    'otp.title': 'Verify Phone',
    'otp.verifying': 'Verifying number',
    'otp.generating': 'Generating OTP...',
    'otp.yourCode': 'Your OTP Code',
    'otp.validity': 'Valid for 10 minutes',
    'otp.enterLabel': 'Enter the OTP shown above',
    'otp.placeholder': '------',
    'otp.verify': 'Verify & Continue',
    'otp.verifyingBtn': 'Verifying...',
    'otp.resend': 'Resend OTP',
    'otp.enterError': 'Enter the 6-digit OTP',

    // My Orders
    'myorders.title': 'My Orders',
    'myorders.subtitle': 'Enter your phone to view your orders',
    'myorders.trackTitle': 'Track Your Orders',
    'myorders.trackSubtext': 'Enter your phone number to view pre-orders and cart orders linked to your account.',
    'myorders.phonePlaceholder': '10-digit mobile number',
    'myorders.verifyBtn': 'Verify with OTP',
    'myorders.signOut': 'Sign out',
    'myorders.found': '{n} order found',
    'myorders.foundPlural': '{n} orders found',
    'myorders.noOrders': 'No orders found for this number.',
    'myorders.preorder': 'Pre-Order',
    'myorders.order': 'Order',
    'myorders.orderedBy': 'Ordered by',
    'myorders.qty': 'Qty',
    'myorders.total': 'Total',

    // Status labels
    'status.pending': 'Pending',
    'status.confirmed': 'Confirmed',
    'status.cancelled': 'Cancelled',

    // Category labels
    'cat.all': 'All',
    'cat.everyday': 'Everyday',
    'cat.premium': 'Premium',
    'cat.exotic': 'Exotic',
    'cat.medicinal': 'Medicinal',

    // Cart additions
    'cart.browseVarieties': 'Browse Varieties',
    'cart.deliveryNote': 'Free delivery above Rs.500 · Per pack pricing',
    'cart.checkoutNote': "Fill in your details before confirming on WhatsApp.",
    'cart.organic': 'Organic',

    // Shop additions
    'shop.clearFilters': 'Clear filters',
    'shop.details': 'Details',
    'shop.onlyLeft': 'Only {n} left',
    'shop.upcoming': 'Upcoming',

    // Detail additions
    'detail.back': 'Back',
    'detail.healthBenefits': 'Health Benefits',
    'detail.bestUses': 'Best Ways to Use',
    'detail.recipeIdeas': 'Recipe Ideas',
    'detail.readyToCook': 'Ready to cook with {name}?',
    'detail.orderFresh': 'Order fresh today — picked and delivered within 24 hours.',
    'detail.addToCartPrice': 'Add to Cart — Rs.{price}',
    'detail.chefTip': "Chef's Tip",
    'detail.viewRecipe': 'View Recipe',
    'detail.preOrderWindow': 'Pre-order open: {from} – {until}',
    'detail.limitedTime': 'Limited time',
    'detail.certOrganic': 'Certified Organic',
    'detail.onlyLeft': 'Only {n} left!',
    'detail.perUom': 'per {uom}',

    // Home page additions
    'home.inKitchen': 'In the Kitchen',
    'home.inspiredRecipes': 'Inspired Recipes',
    'home.recipesSub': 'From quick weeknight stir-fries to gourmet weekend feasts.',
    'home.viewAllVarieties': 'View All Varieties',
    'home.storyLabel': 'Our Story',
    'home.storyTitle': 'Quality you can taste, science you can trust',
    'home.storySub': 'Every pack of PIIKK Agro Farm Fresh Mushrooms is the result of a deliberate, end-to-end quality process — from the substrate to your kitchen.',

    // Podcast
    'podcast.label': 'Learn & Grow',
    'podcast.title': 'Mushroom Podcasts',
    'podcast.subtitle': 'Explore the science, culture and culinary art of fungi through our curated collection.',
    'podcast.openInTab': 'Open in new tab',

    // Recipe Modal
    'recipe.ingredients': 'Ingredients',
    'recipe.steps': 'Instructions',
    'recipe.comingSoon': 'Full recipe details coming soon!',

    // Story Pillars
    'story.pillar1.title': 'Controlled Environment Cultivation',
    'story.pillar1.body': 'We grow in fully enclosed facilities where temperature, humidity, and airflow are precisely managed at every stage. Strict sanitation protocols and contamination-control checkpoints ensure no batch is compromised from spawn to harvest.',
    'story.pillar2.title': 'Trusted Raw Material Sourcing',
    'story.pillar2.body': 'Our compost, spawn, and substrate inputs are procured only from vetted suppliers and partner farmers. Each incoming batch is inspected and logged — we track provenance so that quality is ensured before cultivation even begins.',
    'story.pillar3.title': 'Minimal, Responsible Use of Chemicals',
    'story.pillar3.body': 'We use the lowest possible levels of permitted treatments — strictly limited to preventing nematodes and insecticides in raw materials. Nothing that touches the crop itself goes beyond safe, food-grade thresholds, keeping your mushrooms clean.',
    'story.pillar4.title': 'Strict Gradation & Packing Standards',
    'story.pillar4.body': 'Before packing, every batch goes through a multi-point grading funnel — size, colour, texture, moisture, and aroma. Only mushrooms that meet our benchmarks make it into a PIIKK pack. Reject rates stay high so your quality stays consistent.',

    // Footer
    'footer.whatsapp': 'Order via WhatsApp · 6362516143',
    'footer.copyright': '© 2025 PIIKK Agro Farm Fresh Mushrooms',
  },

  hi: {
    // Navbar
    'nav.shopNow': 'अभी खरीदें',
    'nav.myOrders': 'मेरे ऑर्डर',
    'nav.allVarieties': 'सभी किस्में',
    'nav.recipes': 'रेसिपी',
    'nav.podcasts': 'पॉडकास्ट',
    'nav.about': 'हमारे बारे में',
    'nav.shopByVariety': 'किस्म से खरीदें',
    'nav.viewAll': 'सभी देखें →',
    'nav.menu': 'मेनू',

    // Hero
    'hero.badge': '100% प्रमाणित जैविक',
    'hero.title': 'PIIKK एग्रो फार्म फ्रेश मशरूम',
    'hero.subtitle': 'प्रकृति के सर्वश्रेष्ठ मशरूम — खेत से सीधे आपके दरवाज़े तक।',
    'hero.shopNow': 'अभी खरीदें',
    'hero.explore': 'किस्में देखें',

    // Trust badges
    'trust.organic': '100% प्रमाणित जैविक',
    'trust.organicSub': 'कोई कीटनाशक नहीं',
    'trust.delivery': 'खेत से सीधे डिलीवरी',
    'trust.deliverySub': '24 घंटे में डिलीवरी',
    'trust.quality': 'गुणवत्ता की गारंटी',
    'trust.qualitySub': 'ताज़गी के शिखर पर हाथ से चुना',

    // Featured section
    'featured.label': 'हमारा चयन',
    'featured.title': 'खास किस्में',
    'featured.seeAll': 'सभी देखें',
    'featured.addToCart': 'कार्ट में डालें',
    'featured.preOrder': 'प्री-ऑर्डर',
    'featured.outOfStock': 'स्टॉक खत्म',
    'featured.upcoming': 'जल्द आएगा',

    // Story section
    'story.label': 'हमारी कहानी',
    'story.title': 'वाराणसी की मिट्टी से जुड़े',

    // Stats
    'stats.varieties': 'किस्में',
    'stats.pesticides': 'कीटनाशक मुक्त',
    'stats.graded': 'गुणवत्ता जांच',
    'stats.delivery': 'खेत से दरवाज़े तक',

    // About
    'about.productionUnit': 'उत्पादन केंद्र',

    // Shop page
    'shop.label': 'PIIKK एग्रो फार्म फ्रेश मशरूम',
    'shop.title': 'सभी किस्में',
    'shop.subtitle': '{n} किस्म के प्रमाणित जैविक मशरूम, प्रति पैक मूल्य।',
    'shop.searchPlaceholder': 'मशरूम खोजें...',
    'shop.all': 'सभी',
    'shop.addToCart': 'कार्ट में डालें',
    'shop.preOrder': 'प्री-ऑर्डर',
    'shop.inCart': 'कार्ट में है',
    'shop.upcoming': 'जल्द आएगा',
    'shop.noResults': 'कोई मशरूम नहीं मिला।',
    'shop.perPack': 'प्रति पैक',

    // Mushroom Detail
    'detail.backToShop': 'दुकान पर वापस',
    'detail.addToCart': 'कार्ट में डालें',
    'detail.preOrder': 'प्री-ऑर्डर करें',
    'detail.benefits': 'फायदे',
    'detail.uses': 'उपयोग',
    'detail.recipes': 'रेसिपी',
    'detail.cookingTip': 'पकाने की सलाह',
    'detail.relatedTitle': 'ये भी देखें',
    'detail.inStock': 'उपलब्ध',
    'detail.upcoming': 'प्री-ऑर्डर',
    'detail.uom': 'प्रति पैक',

    // Cart
    'cart.title': 'आपकी कार्ट',
    'cart.empty': 'कार्ट खाली है',
    'cart.emptySubtext': 'ताज़े मशरूम डालें',
    'cart.shopNow': 'खरीदारी करें',
    'cart.checkout': 'व्हाट्सएप पर ऑर्डर करें',
    'cart.total': 'कुल',
    'cart.items': 'आइटम',
    'cart.remove': 'हटाएं',
    'cart.inStock': 'उपलब्ध',

    // Pre-Order Modal
    'preorder.title': 'प्री-ऑर्डर',
    'preorder.enquiryTitle': 'उपलब्धता पूछताछ',
    'preorder.name': 'आपका नाम',
    'preorder.namePlaceholder': 'पूरा नाम',
    'preorder.phone': 'फोन नंबर',
    'preorder.phonePlaceholder': '10 अंक का मोबाइल नंबर',
    'preorder.address': 'डिलीवरी पता',
    'preorder.addressPlaceholder': 'मकान नं., गली, क्षेत्र, शहर, पिनकोड',
    'preorder.qty': 'मात्रा',
    'preorder.date': 'पसंदीदा डिलीवरी तारीख',
    'preorder.dateUnavailable': 'पसंदीदा तारीख (अनुपलब्ध)',
    'preorder.notes': 'टिप्पणी (वैकल्पिक)',
    'preorder.enquiryNotes': 'संदेश (वैकल्पिक)',
    'preorder.notesPh': 'कोई विशेष आवश्यकता?',
    'preorder.enquiryNotesPh': 'कोई प्रश्न या आवश्यकता?',
    'preorder.submit': 'व्हाट्सएप पर प्री-ऑर्डर करें',
    'preorder.enquirySubmit': 'व्हाट्सएप पर पूछताछ भेजें',
    'preorder.loading': 'सहेज रहे हैं...',
    'preorder.verifyNote': 'आपसे फोन नंबर सत्यापित करने के लिए कहा जाएगा।',
    'preorder.verifiedNote': 'फोन सत्यापित। आपका ऑर्डर सहेजा जाएगा।',
    'preorder.successTitle': 'प्री-ऑर्डर हो गया!',
    'preorder.enquirySuccessTitle': 'पूछताछ भेज दी!',
    'preorder.successMsg': '{name} का आपका प्री-ऑर्डर दर्ज हो गया। डिलीवरी तारीख की पुष्टि के लिए नीचे व्हाट्सएप पर बताएं।',
    'preorder.enquirySuccessMsg': '{name} की पूछताछ दर्ज हो गई। हम जल्द संपर्क करेंगे।',
    'preorder.whatsapp': 'व्हाट्सएप पर बताएं',
    'preorder.close': 'बंद करें',
    'preorder.comingSoon': 'जल्द आएगा · उपलब्धता जानें',
    'preorder.chooseBetween': '{from} से {until} के बीच चुनें',
    'preorder.noDatesSet': 'तारीखें अभी तय नहीं — हम बताएंगे।',
    'preorder.enquiryInfo': 'प्री-ऑर्डर विंडो अभी नहीं है। उपलब्ध होने पर संपर्क करेंगे।',

    // Order Form Modal
    'order.title': 'ऑर्डर पूरा करें',
    'order.name': 'आपका नाम',
    'order.namePh': 'पूरा नाम',
    'order.phone': 'फोन नंबर',
    'order.phonePh': '10 अंक का मोबाइल नंबर',
    'order.address': 'डिलीवरी पता',
    'order.addressPh': 'मकान नं., गली, क्षेत्र, शहर, पिनकोड',
    'order.confirm': 'व्हाट्सएप पर ऑर्डर करें',
    'order.verifyNote': 'पुष्टि के लिए फोन सत्यापित करें।',
    'order.verifiedNote': 'फोन सत्यापित। आपका ऑर्डर सहेजा जाएगा।',
    'order.successTitle': 'ऑर्डर हो गया!',
    'order.successMsg': 'आपका ऑर्डर दर्ज हो गया। डिलीवरी की व्यवस्था के लिए नीचे व्हाट्सएप पर बताएं।',
    'order.orderId': 'ऑर्डर आईडी',
    'order.whatsapp': 'व्हाट्सएप पर बताएं',
    'order.close': 'बंद करें',

    // OTP Modal
    'otp.title': 'फोन सत्यापित करें',
    'otp.verifying': 'नंबर सत्यापन',
    'otp.generating': 'OTP बन रहा है...',
    'otp.yourCode': 'आपका OTP कोड',
    'otp.validity': '10 मिनट के लिए वैध',
    'otp.enterLabel': 'ऊपर दिखाया OTP दर्ज करें',
    'otp.placeholder': '------',
    'otp.verify': 'सत्यापित करें',
    'otp.verifyingBtn': 'सत्यापन हो रहा है...',
    'otp.resend': 'OTP दोबारा भेजें',
    'otp.enterError': '6 अंक का OTP दर्ज करें',

    // My Orders
    'myorders.title': 'मेरे ऑर्डर',
    'myorders.subtitle': 'ऑर्डर देखने के लिए फोन नंबर दर्ज करें',
    'myorders.trackTitle': 'अपने ऑर्डर ट्रैक करें',
    'myorders.trackSubtext': 'अपने ऑर्डर और प्री-ऑर्डर देखने के लिए फोन नंबर दर्ज करें।',
    'myorders.phonePlaceholder': '10 अंक का मोबाइल नंबर',
    'myorders.verifyBtn': 'OTP से सत्यापित करें',
    'myorders.signOut': 'साइन आउट',
    'myorders.found': '{n} ऑर्डर मिला',
    'myorders.foundPlural': '{n} ऑर्डर मिले',
    'myorders.noOrders': 'इस नंबर पर कोई ऑर्डर नहीं मिला।',
    'myorders.preorder': 'प्री-ऑर्डर',
    'myorders.order': 'ऑर्डर',
    'myorders.orderedBy': 'ऑर्डर करने वाला',
    'myorders.qty': 'मात्रा',
    'myorders.total': 'कुल',

    // Status labels
    'status.pending': 'लंबित',
    'status.confirmed': 'पुष्टि हो गई',
    'status.cancelled': 'रद्द',

    // Category labels
    'cat.all': 'सभी',
    'cat.everyday': 'रोज़मर्रा',
    'cat.premium': 'प्रीमियम',
    'cat.exotic': 'विदेशी',
    'cat.medicinal': 'औषधीय',

    // Cart additions
    'cart.browseVarieties': 'किस्में देखें',
    'cart.deliveryNote': 'Rs.500 से ऊपर free delivery · per pack pricing',
    'cart.checkoutNote': 'WhatsApp पर confirm करने से पहले details भरें।',
    'cart.organic': 'Organic',

    // Shop additions
    'shop.clearFilters': 'filter हटाएं',
    'shop.details': 'जानकारी',
    'shop.onlyLeft': 'सिर्फ {n} बचे',
    'shop.upcoming': 'जल्द आएगा',

    // Detail additions
    'detail.back': 'वापस',
    'detail.healthBenefits': 'स्वास्थ्य लाभ',
    'detail.bestUses': 'इस्तेमाल कैसे करें',
    'detail.recipeIdeas': 'Recipe Ideas',
    'detail.readyToCook': '{name} बनाने के लिए तैयार?',
    'detail.orderFresh': 'आज order करें — 24 घंटे में ताज़ा delivery।',
    'detail.addToCartPrice': 'Cart में डालें — Rs.{price}',
    'detail.chefTip': "Chef's Tip",
    'detail.viewRecipe': 'Recipe देखें',
    'detail.preOrderWindow': 'Pre-order window: {from} – {until}',
    'detail.limitedTime': 'Limited time',
    'detail.certOrganic': 'Certified Organic',
    'detail.onlyLeft': 'सिर्फ {n} बचे!',
    'detail.perUom': '{uom} का',

    // Home page additions
    'home.inKitchen': 'किचन में',
    'home.inspiredRecipes': 'खास Recipes',
    'home.recipesSub': 'झटपट stir-fry से लेकर weekend के खास पकवान तक।',
    'home.viewAllVarieties': 'सभी किस्में देखें',
    'home.storyLabel': 'हमारी कहानी',
    'home.storyTitle': 'स्वाद महसूस करें, science पर भरोसा रखें',
    'home.storySub': 'PIIKK के हर pack में end-to-end quality — substrate से आपके kitchen तक।',

    // Podcast
    'podcast.label': 'सीखें और बढ़ें',
    'podcast.title': 'Mushroom Podcasts',
    'podcast.subtitle': 'Fungi की science, culture और culinary art को हमारे curated collection से explore करें।',
    'podcast.openInTab': 'नई tab में खोलें',

    // Recipe Modal
    'recipe.ingredients': 'सामग्री',
    'recipe.steps': 'तरीका',
    'recipe.comingSoon': 'पूरी recipe जल्द आएगी!',

    // Story Pillars
    'story.pillar1.title': 'नियंत्रित वातावरण में उत्पादन',
    'story.pillar1.body': 'हम पूरी तरह बंद facilities में उगाते हैं जहाँ temperature, humidity और airflow हर stage पर precisely manage होती है। Strict sanitation और contamination-control checkpoints यह सुनिश्चित करते हैं कि spawn से harvest तक कोई batch खराब न हो।',
    'story.pillar2.title': 'भरोसेमंद raw material sourcing',
    'story.pillar2.body': 'हमारा compost, spawn और substrate सिर्फ verified suppliers और partner farmers से आता है। हर incoming batch की जांच और logging होती है — quality cultivation शुरू होने से पहले ही सुनिश्चित हो जाती है।',
    'story.pillar3.title': 'Chemicals का जिम्मेदार उपयोग',
    'story.pillar3.body': 'हम permitted treatments का न्यूनतम उपयोग करते हैं — सिर्फ raw materials में nematodes और insecticides की रोकथाम के लिए। Crop को छूने वाली कोई भी चीज़ safe, food-grade limits से बाहर नहीं जाती।',
    'story.pillar4.title': 'Strict Grading & Packing Standards',
    'story.pillar4.body': 'Packing से पहले हर batch एक multi-point grading funnel से गुज़रती है — size, colour, texture, moisture और aroma। सिर्फ वही मशरूम PIIKK pack में जाता है जो हमारे standards पर खरा उतरता है।',

    // Footer
    'footer.whatsapp': 'WhatsApp पर order · 6362516143',
    'footer.copyright': '© 2025 PIIKK Agro Farm Fresh Mushrooms',
  }
};

export function t(key, lang = 'en', vars = {}) {
  const str = translations[lang]?.[key] ?? translations['en'][key] ?? key;
  return Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
}
